export const GroupActionTypes = {
  FETCH_GROUPS_START: "FETCH_GROUPS_START_NEW",
  FETCH_GROUPS_SUCCESS: "FETCH_GROUPS_SUCCESS_NEW",
  FETCH_GROUPS_FAILURE: "FETCH_GROUPS_FAILURE_NEW",
  GET_ALL_GROUPS: "GET_ALL_GROUPS_NEW",
  SET_GROUPS_ON_PAGE: "SET_GROUPS_ON_PAGE_NEW",
  SET_SEARCH_GROUPS_QUERY: "SET_SEARCH_GROUPS_QUERY_NEW",
  ADD_SELECTED_GROUP: "ADD_SELECTED_GROUP_NEW",
  DELETE_SELECTED_GROUP: "DELETE_SELECTED_GROUP_NEW",
  SET_SELECTED_GROUP: "SET_SELECTED_GROUP_NEW",
};
